module.exports = __webpack_public_path__ + "img/latitude-interest-free-banner-reversed.88b1985d.svg";